import DOMPurify from 'dompurify';

/**
 * Strip dangerous HTML/script content from markdown source before rendering.
 * ReactMarkdown without rehype-raw already escapes HTML; this adds defense in depth.
 */
export function sanitizeMarkdownSource(markdown: string): string {
  if (!markdown) return '';
  return DOMPurify.sanitize(markdown, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });
}
